import { Box, BoxProps, Center, Text } from '@chakra-ui/react';
import * as React from 'react';

import { Image } from './Image';

export const ImagePlusMore: React.FC<
  {
    src: string | null;
    numOtherImages: number;
  } & BoxProps
> = ({ src, numOtherImages, ...boxProps }) => {
  return (
    <Box
      height={24}
      width={32}
      position="relative"
      _hover={{ cursor: 'pointer' }}
      borderRadius="xl"
      {...boxProps}
    >
      <Image src={src || undefined} alt="" />
      <Center
        position="absolute"
        h="full"
        w="full"
        top={0}
        left={0}
        backgroundColor="blackAlpha.600"
        borderRadius="xl"
      >
        <Text color="white" fontSize="lg" fontWeight="semibold">
          + {numOtherImages} more
        </Text>
      </Center>
    </Box>
  );
};
